export default __webpack_public_path__ + "static/media/standardVoucher.aa78f559.svg";